import { render } from "./FrisbuyPopupAlertConditions.vue?vue&type=template&id=9da7241e&scoped=true"
import script from "./FrisbuyPopupAlertConditions.vue?vue&type=script&lang=js"
export * from "./FrisbuyPopupAlertConditions.vue?vue&type=script&lang=js"

import "./FrisbuyPopupAlertConditions.vue?vue&type=style&index=0&id=9da7241e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da7241e"]])

export default __exports__